




















































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import WholeProcessApi from '@/api/wholeProcess'
import RevisitApi from '@/api/revisit'
import { columns } from '@/views/AiiTasks/wholeProcess/config'
import listMixins from '@/mixins/list'

@Component({
	name: 'wholeProcessList',
	components: {
		PageLayout,
	},
})
export default class WholeProcessList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []

	private goToDetail(row: any) {
		return `/AiiTasks/wholeProcessDetail/${row.id}`
	}

	private getForm() {
		const form: any = this.getSearchValues()

		form.beginCreateTime =
			form.startendTime &&
			form.startendTime[0] &&
			form.startendTime[0].format('YYYY-MM-DD')
		form.endCreateTime =
			form.startendTime &&
			form.startendTime[1] &&
			form.startendTime[1].format('YYYY-MM-DD')
		delete form.startendTime

		// form.beginFinshTime =
		// 	form.finishTime &&
		// 	form.finishTime[0] &&
		// 	form.finishTime[0].format('YYYY-MM-DD')
		// form.endFinshTime =
		// 	form.finishTime &&
		// 	form.finishTime[1] &&
		// 	form.finishTime[1].format('YYYY-MM-DD')
		// delete form.finishTime

		let temp =
			typeof form.company.value === 'string'
				? form.company.value.trim()
				: form.company.value
		if (temp || temp === 0) {
			form.companyId = temp
		}
		delete form.company

		return form
	}

	public getList() {
		return WholeProcessApi.getWPList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.getList()
	}
}
